module.exports = __webpack_public_path__ + "img/Slice7.63a701a8.png";